module.exports = __webpack_public_path__ + "static/media/ashnik.3dd3afaf.png";